export default "__VITE_ASSET__DHtWvqo$__"